
const routes = {
    CREATOR: '/creator',
    LOGIN:'/login',
    SIGNUP:'/signup',
    DISCOVER:'/discover',
    ADDTOCART:'/cart',
    CHECKOUT:'/checkout',
    ADDRESSE:'/addresse',
    PRODUCT_DETAILS:'/detailsproduct/:id',
    DETAILS:'/details',
    PROFILE:'/profile/*',
    USER_PROFILE:'/userprofile',
    USER_PRODUCTS:'/products',
    RETURN_AND_REFUND:'/ReturnandRefund',
    STYLES:'/styles',
    MY_ACCOUNT:'/myaccount',
    MY_ADDRESS:'/myaddress',
    CHANGE_PASSWORD:'/changepassword',
    FORGOT_PASSWORD:'/forgotpassword',
    NOTIFY:'/notify',
    MY_CART:'/mycart',
    DISCOVER_DETAILS:'/discoverdetails'




}
export default routes